<template>

  <vx-card class="p-0" :title="((newEmployee) ? $t('new') : $t('update_a')) + ' ' + $t('Employee')">

    <form-wizard color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" finishButtonText="Submit">
<!-- Personal_information

    School_information 
    
    matricule: '',
    nom: '',
    prenoms: '',
    full_name: '',
    dateNaissance: '',
    sexe: '',
    adresse: '',
    telephone1: '',
    -->
      <tab-content :title="$t('Personal_information')" class="mb-5" :before-change="Personal_information_validate">
        <form data-vv-scope="Personal_information">
          <div class="vx-row">
            <div class="mb-4 vx-col md:w-1/3 w-full">
              <p > {{ $t('Date_of_Birth') }} </p>
              <datepicker v-model="input.employe.dateNaissance"></datepicker>
              <!-- <span class="text-danger">{{ errors.first('Personal_information.dateNaissance') }}</span> -->
            </div>
            <div class="mb-4 vx-col md:w-1/3 w-full">
              <p > {{ $t('sex') }} </p>
              <v-select 
                :options="sexes" 
                :reduce="rep => rep.id"
                @search="getSexe" 
                :clearable="true" 
                label="libelle" 
                v-model="input.employe.sexe" class="w-full" 
                />                
              <!-- <span class="text-danger">{{ errors.first('Personal_information.sexe') }}</span> -->
            </div>
            <div class="mb-4 vx-col md:w-1/3 w-full">
              <p> {{ $t('Last_name') }} </p>
              <vs-input v-model="input.employe.nom" class="w-full" />
              <!-- <span class="text-danger">{{ errors.first('Personal_information.nom') }}</span> -->
            </div>
            <div class="mb-4 vx-col md:w-1/3 w-full">
              <p> {{ $t('First_names') }} </p>
              <vs-input v-model="input.employe.prenoms" class="w-full" />
              <!-- <span class="text-danger">{{ errors.first('Personal_information.prenoms') }}</span> -->
            </div>
            <div class="mb-4 vx-col md:w-1/3 w-full">
              <p> {{ $t('Address') }} </p>
              <vs-input v-model="input.employe.adresse" class="w-full" />
              <!-- <span class="text-danger">{{ errors.first('Personal_information.adresse') }}</span> -->
            </div>
            <div class="mb-4 vx-col md:w-1/3 w-full">
              <p> {{ $t('place_of_birth') }} </p>
              <vs-input v-model="input.employe.lieuNaissance" class="w-full" />
              <!-- <span class="text-danger">{{ errors.first('Personal_information.lieuNaissance') }}</span> -->
            </div>
            <div class="mb-4 vx-col md:w-1/3 w-full">
              <p> {{ $t('person_to_contact') }} </p>
              <vs-input v-model="input.employe.personnePrevenir" class="w-full" />
              <!-- <span class="text-danger">{{ errors.first('Personal_information.personnePrevenir') }}</span> -->
            </div>
            <div class="mb-4 vx-col md:w-1/3 w-full">
              <p> {{ $t('post_box') }} </p>
              <vs-input v-model="input.employe.bp" class="w-full" />
              <!-- <vs-input v-model="input.employe.bp" class="w-full" name="bp" v-validate="'required'" /> -->
              <!-- <span class="text-danger">{{ errors.first('Personal_information.bp') }}</span> -->
            </div>
            <div class="mb-4 vx-col md:w-1/3 w-full">
              <p> {{ $t('city') }} </p>
              <vs-input v-model="input.employe.ville" class="w-full" />
              <!-- <span class="text-danger">{{ errors.first('Personal_information.ville') }}</span> -->
            </div>
            <div class="mb-4 vx-col md:w-1/3 w-full">
              <p> {{ $t('district') }} </p>
              <vs-input v-model="input.employe.quartier" class="w-full" />
              <!-- <span class="text-danger">{{ errors.first('Personal_information.quartier') }}</span> -->
            </div>
            <div class="mb-4 vx-col md:w-1/3 w-full">
              <p> {{ $t('Phone_number_1') }} </p>
              <vs-input v-model="input.employe.telephone1" class="w-full" />
              <!-- <span class="text-danger">{{ errors.first('Personal_information.telephone1') }}</span> -->
            </div>
            <div class="mb-4 vx-col md:w-1/3 w-full">
              <p> {{ $t('Phone_number_2') }} </p>
              <vs-input v-model="input.employe.telephone2" class="w-full" />
            </div>
          </div>
        </form>
      </tab-content>
      
      <tab-content :title="$t('School_information')" class="mb-5" :before-change="School_information_validate">
        <form data-vv-scope="School_information">
        <div class="vx-row">
          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p> {{ $t('Cnss_Registration_number') }} </p>
            <vs-input v-model="input.employe.matriculeCnss" class="w-full" />
            <!-- <span class="text-danger">{{ errors.first('School_information.matriculeCnss') }}</span> -->
          </div>
          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p > {{ $t('Entry_date') }} </p>
            <datepicker v-model="input.employe.dateEntree" ></datepicker>
            <!-- <span class="text-danger">{{ errors.first('School_information.dateEntree') }}</span> -->
          </div>
          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p > {{ $t('level') }} </p>
            <v-select 
              :options="niveaus"
              :reduce="rep => rep.id" 
              @search="getNiveau" 
              :clearable="true" 
              label="libelle" 
              v-model="input.niveau" 
              class="w-full" />                
            <!-- <span class="text-danger">{{ errors.first('School_information.niveau') }}</span> -->
          </div>
          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p > {{ $t('occupied_position') }} </p>
            <v-select 
              multiple
              :options="postes" 
              @search="getPoste"
              :reduce="rep => rep.id"
              :clearable="true" 
              label="libellePoste" 
              v-model="input.postes_add" class="w-full" 
              />                
            <!-- <span class="text-danger">{{ errors.first('School_information.poste') }}</span> -->
          </div>
          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p > {{ $t('Marital_status') }} </p>
            <v-select 
              :options="situationMatrimoniales" 
              @search="getSituationMatrimoniale"
              :reduce="rep => rep.id"
              :clearable="true" 
              label="libelle"
              v-model="input.employe.situation" class="w-full" 
              />                
            <!-- <span class="text-danger">{{ errors.first('School_information.situation') }}</span> -->
          </div>
          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p> {{ $t('filiation') }} </p>
            <vs-input v-model="input.employe.filiation" class="w-full" />
            <!-- <span class="text-danger">{{ errors.first('School_information.filiation') }}</span> -->
          </div>
          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p> {{ $t('number_of_people') }} <!-- <b style="color: #ff6141">*</b> --> </p>
            <vs-input-number v-model="input.employe.nbre_personnes_charge" class="ml-0" />
            <!-- <span class="text-danger">{{ errors.first('School_information.nbre_personnes_charge') }}</span> -->
          </div>
          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p> {{ $t('Gross_wages') }} </p>
            <vs-input-number v-model="input.employe.salaire_brute" class="ml-0" />
            <!-- <span class="text-danger">{{ errors.first('School_information.salaire_brute') }}</span> -->
          </div>
          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p> {{ $t('declared') }} ? </p>
            <vs-switch color="success" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="input.employe.declarer">
              <span slot="on">{{ $t("YES") }}</span>
              <span slot="off">{{ $t("NO") }}</span>
            </vs-switch>
          </div>
          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p> {{ $t('withoutTcs') }} ? </p>
            <vs-switch color="success" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="input.employe.sansTcs">
              <span slot="on">{{ $t("YES") }}</span>
              <span slot="off">{{ $t("NO") }}</span>
            </vs-switch>
          </div>
          <!-- banqueDeDomiciliation -->
          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p > Accorder une prime non imposable </p>
            <v-select
              multiple
              :options="primeNonImposabless"
              :reduce="rep => rep.id" 
              :clearable="true" 
              :getOptionLabel="getOptionLabel"
              v-model="input.employe.primeNonImposables_add" 
              class="w-full" />                
            <!-- <span class="text-danger">{{ errors.first('School_information.niveau') }}</span> -->
          </div>

          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p > Banque de domiciliation </p>
            <v-select 
              :options="banques"
              :reduce="rep => rep.id" 
              @search="getBanque" 
              :clearable="true" 
              label="libelle" 
              v-model="input.employe.banqueDeDomiciliation" 
              class="w-full" />                
            <!-- <span class="text-danger">{{ errors.first('School_information.niveau') }}</span> -->
          </div>

          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p > Accorder une prime imposable </p>
            <v-select
              multiple
              :options="primeNonImposabless"
              :reduce="rep => rep.id" 
              :clearable="true" 
              :getOptionLabel="getOptionLabel"
              v-model="input.employe.primeImposables_add" 
              class="w-full" />                    
            <!-- <span class="text-danger">{{ errors.first('School_information.niveau') }}</span> -->
          </div>

          <div class="mb-4 vx-col md:w-1/2 w-full">
            <p> Compte bancaire </p>
            <vs-input v-model="input.employe.compteBancaire" class="w-full" />
          </div>          
        </div>
        </form>
      </tab-content>
      
    </form-wizard>
  </vx-card>
</template>

<script>
// let annee_en_cour = 0
let base_self = ''
import Datepicker from 'vuejs-datepicker'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

// For custom error message
import { Validator } from 'vee-validate'

// Employee
const input_tempon = {
  niveau: '',
  anneeScolaire: '',
  employe: {
    compteBancaire: '',
    banqueDeDomiciliation: '',
    matriculeCnss: '',
    dateEntree: '',
    situation: '',
    filiation: '',
    nbre_personnes_charge: '',
    declarer: false,
    sansTcs: '',
    salaire_brute: '',
    etat: true,
    dateNaissance: '',
    sexe: '',
    primeImposables: [],
    primeNonImposables_add: [],
    full_name: '',
    nom: '',
    prenoms: '',
    adresse: '',
    lieuNaissance: '',
    personnePrevenir: '',
    bp: '',
    ville: '',
    quartier: '', 
    telephone1: '',
    telephone2: ''
  },
  postes_add: []
}


export default {
  watch: {
    /* input: {
      handler  () {
        base_self.input_watch(false)
      },
      deep: true
    } */
  },
  data () {
    return {
      input1: JSON.parse(JSON.stringify(input_tempon)),
      input: JSON.parse(JSON.stringify(input_tempon)),
      newEmployee: true,
      formwizard1: false,
      formwizard: false,
      desired: true,
      classe_input: {},
      frais_input: {},
      frais_input1: {},
      classes: [],
      input_classes: [],
      popupActive: false,
      id_general: '',
      sexes: [],
      sexes1: [],
      primeImposabless: [],
      primeNonImposabless: [],
      banques: [],
      postes: [],
      situationMatrimoniales: [],
      niveaus: []
    }
  },
  methods: {
    getOptionLabel (option) {
      if (typeof option === 'object') {
        // const length = this.label.length

        const solde = new Intl.NumberFormat('de-DE').format(option.solde)
        
        return `${option.libelle} ( ${solde} )`
        /* for (let i = 0; i < length; i++) {
          if (element && !element.hasOwnProperty(this.label[i])) {
            return console.warn(
              `[vue-select warn]: Label key "option.${this.label}" does not` +
              ` exist in options object ${JSON.stringify(option)}.\n` +
              'https://vue-select.org/api/props.html#getoptionlabel'
            )
          }

          element = element ? element[this.label[i]] : ''
        } */

        // return option['created_at']
        
      }
      return option
    },
    getNumeroMatricule () {
      const data = {
        is_get: true,
        paginate: {
          length: 1,
          page: 1
        },
        filter: { },
        orderby: ['-id']
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Eleve`, data)
        .then((response) => {
          if (response.data.data.length) {
            base_self.input.employe.rang = response.data.data[0].rang + 1
          } else {
            base_self.input.employe.rang = 1
          }
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getAll () {
      base_self.getPosteSimple()
      base_self.getNiveauSimple()
      base_self.getSexeSimple()
      base_self.getPrimeSimple()
      base_self.getBanqueSimple()
      base_self.getSituationMatrimonialeSimple()
    },
    getPosteByEmployer (id) {
      const data = {
        is_get: true,
        paginate: {
          length: 5000,
          page: 1
        },
        filter: { postEmployes__id: id }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Poste`, data)
        .then((response) => {
          const postes = []
          const length = response.data.data.length
          for (let i = 0; i < length; i++) {
            postes.push(response.data.data[i].id)
          }

          base_self.getPostEmployeOne(id, postes)
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getPrimeEmployer (input) {
      const data = {
        employeId: input.employe.id
      }

      console.log('data: ', data)

      base_self.$http.post(`${base_self.$store.state.route_for_esm}liaison-many-to-many-employe`, data)
        .then((response) => {
          console.log('response.data', response.data)

          input.employe.primeImposables_add = response.data.primeImposables_add
          input.employe.primeNonImposables_add = response.data.primeNonImposables_add
          base_self.input = input

          console.log('input.employe: ', input.employe)
          
          base_self.getAll()
        })
        .catch((error) => {
          console.error(' -------- ', error)
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    },
    getPostEmployeOne (id, postes) {
      const data = {
        is_get: true,
        filter: { id }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}PostEmploye`, data)
        .then((response) => {
          const input = JSON.parse(JSON.stringify(response.data.data[0]))
          if (input.niveau) input.niveau = input.niveau.id
          if (input.anneeScolaire) input.anneeScolaire = input.anneeScolaire.id

          input.postes_add = postes

          if (input.employe.banqueDeDomiciliation) input.employe.banqueDeDomiciliation = input.employe.banqueDeDomiciliation.id
          if (input.employe.sexe) input.employe.sexe = input.employe.sexe.id
          if (input.employe.situation) input.employe.situation = input.employe.situation.id

          // base_self.getAllPrime()

          // console.log('input.employe: ', input.employe)
          base_self.getPrimeEmployer(input)
          
          base_self.getAll()
        })
        .catch((error) => {
          console.error(' -------- ', error)
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    },
    getAnneeEnCours () {
      const data = {
        is_get: true,
        filter: { cloture: false, encours: true }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}AnneeScolaire`, data)
        .then((response) => {
          if (!response.data.data.length) {
            window.getESM.error(base_self.$t('There_is_no_open_school_year'))
            base_self.$router.push('/Employee_management/Employee').catch(() => {})
          } else {
            // annee_en_cour = response.data.data[0].anneeDebut.valeur % 100

            base_self.input.anneeScolaire = response.data.data[0].id
            base_self.getAll()
          }

        })
        .catch((error) => {
          console.error(' -------- ', error)
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    },
    delete_parent (index) {
      base_self.input.employe.parents_add.splice(index, 1)
    },
    validerFonction () {
      base_self.popupActive = false
      // base_self.formwizard1 = true
      base_self.initialiseElement()
    },
    getClasse (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true, niveau__is_active: true, libelle__icontains: search },
        orderby: ['ordre']
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          base_self.classes = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    errorsFirst (libelle, id, index) {
      return `step-${id}.${libelle}${index}`
    },
    getSexeSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Sexe`, data)
        .then((response) => {
          base_self.sexes = response.data.data
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getSexe (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Sexe`, data)
        .then((response) => {
          base_self.sexes = response.data.data
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getPrimeSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 1000,
          page: 1
        },
        filter: { }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Prime`, data)
        .then((response) => {
          base_self.primeImposabless = response.data.data
          base_self.primeNonImposabless = response.data.data
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getPrime (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Prime`, data)
        .then((response) => {
          base_self.primeImposabless = response.data.data
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getPrimeNonImposables (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Prime`, data)
        .then((response) => {
          base_self.primeNonImposabless = response.data.data
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getBanqueSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Banque`, data)
        .then((response) => {
          base_self.banques = response.data.data
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getBanque (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Banque`, data)
        .then((response) => {
          base_self.banques = response.data.data
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getSituationMatrimonialeSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}SituationMatrimoniale`, data)
        .then((response) => {
          base_self.situationMatrimoniales = response.data.data
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getSituationMatrimoniale (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}SituationMatrimoniale`, data)
        .then((response) => {
          base_self.situationMatrimoniales = response.data.data
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getPosteSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Poste`, data)
        .then((response) => {
          base_self.postes = response.data.data
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getPoste (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Poste`, data)
        .then((response) => {
          base_self.postes = response.data.data
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getNiveau (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search, is_active: true }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Niveau`, data)
        .then((response) => {
          base_self.niveaus = response.data.data
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getNiveauSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Niveau`, data)
        .then((response) => {
          base_self.niveaus = response.data.data
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    Personal_information_validate () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('Personal_information').then(result => {
          if (result) {
            // base_self.submit()
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    School_information_validate () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('School_information').then(result => {
          if (result) {
            base_self.submit()
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    async submit () {
      base_self.$vs.loading()
      
      const input = JSON.parse(JSON.stringify(base_self.input))

      input.employe.full_name = `${input.employe.nom} ${input.employe.prenoms}`

      console.log(' input ', input)
      
      if (!input.id) {
        base_self.$http.post(`${base_self.$store.state.route_for_esm}PostEmploye`, input)
          .then((response) => { 

            console.log('response: ', response)
            console.log('response: ', response)
            console.log('response: ', response)
            console.log('response: ', response)
            
            window.getESM.success(base_self.$t('The_employee_is_added_successfully'), response)
            base_self.$vs.loading.close()
            
            // console.log(' response ', response)
            base_self.$router.push('/Employee_management/Employee').catch(() => {})
          })
          .catch((error) => { 
            console.log('error: ', error)
            base_self.$vs.loading.close()
          })

      } else if (input.id) {
        base_self.$http.put(`${base_self.$store.state.route_for_esm}PostEmploye`, input)
          .then((response) => { 

            console.log('response: ', response)
            console.log('response: ', response)
            console.log('response: ', response)
            console.log('response: ', response)

            window.getESM.success(base_self.$t('The_employee_is_changed_successfully'), response)
            base_self.$vs.loading.close()
            base_self.$router.push('/Employee_management/Employee').catch(() => {})
          })
          .catch((error) => { 
            console.log('error: ', error)
            base_self.$vs.loading.close()
          })
      }
    },
    async getTypeFraiss () {
      const param = {
        is_get: true,
        filter: {
        }
      }

      base_self.$http.post(`${base_self.$store.state.route_for_esm}TypeFrais`, param)
        .then((response) => {
          base_self.typeFraiss = response.data.data
          base_self.initialiseElement()
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    }
  },
  components: {
    Datepicker,
    FormWizard,
    TabContent
  },
  created () {
    base_self = this
    
    ///////////////////////////
    const dict = {
      custom: {
        dateNaissance: {
          required: base_self.$t('The_Date_of_Birth_is_required')
        },
        sexe: {
          required: base_self.$t('The_sex_is_required')
        },
        nom: {
          required: base_self.$t('The_Last_name_is_required')
        },
        prenoms: {
          required: base_self.$t('The_First_names_is_required')
        },
        adresse: {
          required: base_self.$t('The_Address_is_required')
        },
        lieuNaissance: {
          required: base_self.$t('The_place_of_birth_is_required')
        },
        personnePrevenir: {
          required: base_self.$t('The_person_to_contact_is_required')
        },
        bp: {
          required: base_self.$t('The_post_box_is_required')
        },
        ville: {
          required: base_self.$t('The_city_is_required')
        },
        quartier: {
          required: base_self.$t('The_district_is_required')
        },
        telephone1: {
          required: base_self.$t('The_Phone_number_1_is_required')
        },
        matriculeCnss: {
          required: base_self.$t('The_Cnss_Registration_number_is_required')
        },
        compteBancaire: {
          required: 'Le compte bancaire est réquis'
        },
        dateEntree: {
          required: base_self.$t('The_Entry_date_is_required')
        },
        niveau: {
          required: base_self.$t('The_level_is_required')
        },
        poste: {
          required: base_self.$t('The_post_is_required')
        },
        situation: {
          required: base_self.$t('The_Marital_status_is_required')
        },
        filiation: {
          required: base_self.$t('The_filiation_is_required')
        },
        nbre_personnes_charge: {
          required: base_self.$t('The_number_of_people_in_charge_is_required')
        },
        salaire_brute: {
          required: base_self.$t('The_Gross_wages_is_required')
        }
      }
    }
    // register custom messages
    Validator.localize('en', dict)
    //////////////////////////
    
    const id = Number(base_self.$route.params.id)
    if (id !== 0) {
      base_self.newEmployee = false
    }

    if (base_self.newEmployee) {
      base_self.getAnneeEnCours()
    } else {
      base_self.getPosteByEmployer(id)
    }
    
  }
}
</script>

<style>
[dir] .vs__dropdown-toggle {
  border-radius: 20px;
}

[dir] .vdp-datepicker input {
  border-radius: 20px;
}
</style>